<ng-container *ngIf="(homePageContent$ | async) as content">
  <div class="home-page">
    <div class="home-page-top" [ngStyle]="homeBannerStyles(content)">

      <div class="banner-content">
        <img class="company-logo" [src]="content.logoImageUrl" *ngIf="content.logoImageUrl">

        <h1 class="banner-title" [ngStyle]="calculateTitleStyles(content)">{{content.pageTitle}}</h1>

        <div *ngIf="!content.logoImageUrl && !content.bannerImageUrl" class="instructor-hint">
          {{ ("home.checkThis" | translate) }} <a target="_blank"
            href="https://instructor-academy.onlinecoursehost.com/how-to-create-an-online-course-thumbnail/">{{
            ("home.guide" | translate) }}</a> {{ ("home.learnHowToGetGreatLookingLogos" | translate) }}
        </div>

        <div class="btn-actions">

          <!--button class="cta-button" mat-raised-button color="accent" *ngIf="isLoggedOut$ | async"
                  (click)="onSignupClicked()">

            <mat-icon>account_circle</mat-icon>

            {{ ("home.signUpNow" | translate) }}

          </button -->

          <!-- button class="cta-button" mat-raised-button color="accent"
                  *ngIf="(isLoggedIn$ | async) && content.showViewCoursesButton"
                  routerLink="/courses">

            <mat-icon>library_books</mat-icon>

            {{ ("home.viewCourse" | translate) }}

          </button -->

          <button class="btn-accent" *allowRole="['ADMIN']" (click)="editPageHeader(content)">
            <span class="material-symbols-outlined">
              edit
            </span>
            <span>{{ ("home.editHeader" | translate) }}</span>
          </button>

        </div>

      </div>

    </div>
    <div class="home-page-middle element-padding">
      <div class="container">
        <div class="benefits">
          <ul>
            <li *ngFor="let benefit of content.benefits; let index = index">
              <editable-container [editModeEnabled]="editModeEnabled" (editRequested)="onBenefitEdited(content, index)">
                <div class="benefit-list d-flex align-items-start">
                  <div class="icon-wrapper">
                    <span class="material-symbols-outlined">
                      check
                    </span>
                  </div>
                  <div class="benefit-wrapper">
                    <h3 class="html-content" [innerHtml]="benefit.title | safeHtml"></h3>
                    <span class="benefit-text html-content" [innerHtml]="benefit.description | safeHtml"></span>
                  </div>
                </div>
              </editable-container>
            </li>
          </ul>
        </div>
        <ng-container *ngIf="(tenant$ | async) as tenant">
          <div class="latest-lessons" *ngIf="!tenant?.allLessonsTabOff">
            <latest-lessons-list title="{{ ('home.latestLessons' | translate) }}"></latest-lessons-list>
          </div>
        </ng-container>
      </div>
    </div>
    <div class="home-page-bottom element-padding">
      <div class="container">
        <ng-container *ngIf="publishedCourses">
          <h1 class="page-title">{{ ("home.allCourses" | translate) }}</h1>
          <div class="course-filter-wrapper">
            <course-filter [isSwapCardView]="isSwapCardView" (swapCard)="swapCardView()"
              (filterPerCategories)="onFilterPerCategoryChanged($event)">
            </course-filter>
          </div>
          <div class="courses-list" *ngIf="publishedCourses.length; else noCourses">
            <div class="row">
              <div class="col-12 col-md-6 col-lg-4 card-mode" [ngClass]="{ 'list-mode': !isSwapCardView }"
                *ngFor="let course of (filteredCourses?.length ? filteredCourses : publishedCourses);let first= first; let last = last">
                <course-card [course]="course" [allowReorder]="false" [isSwapCardView]="isSwapCardView">
                </course-card>
              </div>
            </div>
          </div>
          <ng-template #noCourses>
            <div class="no-content">

              <span>{{ ("home.noCoursePublishedYet" | translate) }}</span>

            </div>
          </ng-template>
        </ng-container>
      </div>
    </div>
    <ng-container *ngIf="isLoggedOut$ | async">
      <ng-container *ngIf="(tenant$ | async) as tenant">
        <div class="newsletter-form" *ngIf="!tenant?.newsletter?.newsletterFormDisabled">
          <newsletter mode="home-page"></newsletter>
        </div>
      </ng-container>
    </ng-container>
  </div>
  <page-footer></page-footer>
</ng-container>
